import * as React from 'react';

const CoffeeSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M5 21h12v1H5zM16 13.3c0 3.2-2.2 5.7-5 5.7s-5-2.6-5-5.7V11h10v2.3zm1-.3h2v-2h-2v2zm3-3H5v3.3C5 17 7.7 20 11 20c3.1 0 5.7-2.6 6-6h3v-4z"
        />
        <g fillRule="evenodd" clipRule="evenodd" fill="#231F20">
            <path d="M12.5 3h-1v.5c0 .8-.7 1.5-1.5 1.5-1.4 0-2.5 1.1-2.5 2.5V8h1v-.5c0-.8.7-1.5 1.5-1.5 1.4 0 2.5-1.1 2.5-2.5V3zM16 3v.5c0 .8-.7 1.5-1.5 1.5C13.1 5 12 6.1 12 7.5V8h1v-.5c0-.8.7-1.5 1.5-1.5C15.9 6 17 4.9 17 3.5V3h-1z" />
        </g>
    </svg>
);

CoffeeSvg.displayName = 'CoffeeSvg';
export default CoffeeSvg;
